import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getDataTypesAsync(type) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/dataType/all/' + type, HEADER);
				return res;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async saveDataType(dataType) {
		let { title, type, isBasic, fields, options } = dataType;
		const HEADER = await sesionService.getHeader();
		try {
			let res = await axios.post(
				'/dataType',
				{ title, type, isBasic, fields, options },
				HEADER
			);
			return res.data;
		} catch (error) {
			console.log(error);
			//window.location.href = '/legajos';
		}
	},

	async getDataTypeById(id) {
		const HEADER = await sesionService.getHeader();
		try {
			let res = await axios.get(`/dataType/${id}`, HEADER);
			return res.data;
		} catch (error) {
			console.log(error);
			//window.location.href = '/legajos';
		}
	},

	async updateDataType(id, dataType) {
		let { title, type, isBasic, fields, options } = dataType;
		const HEADER = await sesionService.getHeader();

		try {
			let res = await axios.put(
				`/dataType/${id}`,
				{ title, type, isBasic, fields, options },
				HEADER
			);
			return res.data;
		} catch (error) {
			console.log(error);
		}
	},

	async deleteDataType(id) {
		const HEADER = await sesionService.getHeader();
		try {
			let res = await axios.delete(`/dataType/${id}`, HEADER);
			return res.data;
		} catch (error) {
			console.log(error);
		}
	},

	async canEditOrDelete(id) {
		const HEADER = await sesionService.getHeader();
		try {
			let res = await axios.get(`/dataType/canEditOrDelete/${id}`, HEADER);
			return res.data;
		} catch (error) {
			console.log(error);
		}
	}
};
